import getEmailAddressFromSipUri from '../../presenceManager/getEmailAddressFromSipUri';
import getPresenceFromStore from '../../presenceManager/getPresenceFromStore';
import getRecipientDisplayName from '../selectors/getRecipientDisplayName';
import { ucmaDisplayNameWithOthers } from '../strings.locstring.json';
import { IPersonaProps, PersonaSize } from '@fluentui/react/lib/Persona';
import { Icon } from '@fluentui/react/lib/Icon';
import { TooltipHost, TooltipOverflowMode } from '@fluentui/react/lib/Tooltip';
import { ControlIcons } from 'owa-control-icons';
import loc, { format } from 'owa-localize';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import * as React from 'react';
import ChatViewState from '../store/schema/ChatViewState';

export interface ChatPersonaProps {
    linkedChatViewState: ChatViewState;
    hidePersonaDetails?: boolean;
    primaryTextClassName?: string;
}

const styles = require('./ChatPersona.scss');
const classNames = require('classnames/bind').bind(styles);

export default function ChatPersona(props: ChatPersonaProps) {
    const { linkedChatViewState, hidePersonaDetails, primaryTextClassName } = props;
    const sipUri = linkedChatViewState.participants[0];
    const numberMembers = linkedChatViewState.participants.length;
    const subject = linkedChatViewState.subject;
    const isGroup = numberMembers > 1;

    const onRenderPrimaryText = React.useCallback(
        (personaProps: IPersonaProps) => {
            let stringToRender;
            if (subject) {
                stringToRender = subject;
            } else {
                const firstDisplayName = getRecipientDisplayName(sipUri);
                stringToRender = isGroup
                    ? format(loc(ucmaDisplayNameWithOthers), firstDisplayName, numberMembers - 1)
                    : firstDisplayName;
            }
            return (
                <TooltipHost content={stringToRender} overflowMode={TooltipOverflowMode.Parent}>
                    {stringToRender}
                </TooltipHost>
            );
        },
        [sipUri, numberMembers, subject]
    );

    const onRenderGroupPersonaCoin = React.useCallback((personaProps: IPersonaProps) => {
        return <Icon iconName={ControlIcons.People} className={styles.groupIcon} />;
    }, []);

    const firstRecipientDisplayName = getRecipientDisplayName(sipUri);

    return (
        <PersonaControl
            emailAddress={getEmailAddressFromSipUri(sipUri)}
            name={firstRecipientDisplayName}
            size={PersonaSize.size24}
            presence={isGroup ? undefined : getPresenceFromStore(sipUri)}
            showPersonaDetails={!hidePersonaDetails}
            showPresence={!isGroup}
            onRenderPrimaryText={onRenderPrimaryText}
            onRenderCoin={isGroup ? onRenderGroupPersonaCoin : undefined}
            coinProps={
                isGroup
                    ? {
                          styles: {
                              imageArea: styles.coinGroupImageArea,
                              // We need to explicitly display: none the initials here due to a bug in fabirc.
                              // https://github.com/OfficeDev/@fluentui/react/issues/9340
                              initials: isGroup ? styles.hideInitials : undefined,
                          },
                      }
                    : undefined
            }
            styleProps={{
                primaryText: classNames(styles.personaText, primaryTextClassName),
                details: isGroup || subject ? styles.paddingRightReset : undefined,
            }}
        />
    );
}
